export class UserSubscriptionStatus {

  public static active: string = 'active';
  public static failed: string = 'failed';
  public static canceled: string = 'canceled';
  public static renewed: string = 'renewed';
  public static expired: string = 'expired';

}

